import React from 'react';
import { cn } from '../../lib/cn';
type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}
const variants: Record<Variant, string> = {
  primary: 'bg-ink text-white hover:bg-black shadow-sm border border-transparent',
  secondary: 'bg-white text-ink border border-line hover:bg-surface',
  ghost: 'bg-transparent text-ink-soft hover:bg-surface hover:text-ink border border-transparent',
  danger: 'bg-white text-neg border border-neg-border hover:bg-neg-soft'
};
const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-[13px] gap-1.5 rounded-lg',
  md: 'h-10 px-4 text-sm gap-2 rounded-xl'
};
export function Button({
  variant = 'secondary',
  size = 'md',
  className,
  ...rest
}: ButtonProps) {
  return <button className={cn('inline-flex items-center justify-center font-medium transition-all duration-150 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className)} {...rest} data-id="element-584" data-mp="35w9pvd5fj58" />;
}